/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { CourseCardListElement } from '../components/PictureCard'

export class CourseCardList extends HTMLElement {
  connectedCallback() {
    const mountPoint = document.createElement('div')
    this.attachShadow({ mode: 'open' }).appendChild(mountPoint)

    createRoot(mountPoint).render(<CourseCardListElement styleRoot={mountPoint} />);
  }
  //attributeChangedCallback(name, oldValue, newValue) { // 4th W3C parameter = Namespace (not implemented in Browsers)
  //}
  //disconnectedCallback(){}
}
customElements.define('course-card-list', CourseCardList)
